import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { encodeURL } from 'src/app/services/parseURL';
import { VendorService } from 'src/app/services/vendor/vendor.service';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';
import { DesignStudioService } from 'src/app/services/design-studio/design-studio.service';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-widget-vendors',
  templateUrl: './widget-vendors.component.html',
  styleUrls: ['./widget-vendors.component.scss'],
})
export class WidgetVendorsComponent implements OnInit {

  @Input() widgetID: any;
  @Input() widgetTitle: any;
  isGPSPermission = false;
  vendors = [];
  loading: boolean = false;
  designStudioActive;
  widgetData;
  widgetStyle;
  colClass;
  background:any ;
  constructor(
    private widgetsService: WidgetsService,
    private router: Router,
    private designStudioService: DesignStudioService,
    private domSanitizer: DomSanitizer,
    private vendorService: VendorService) { }

  async ngOnInit() {
    this.designStudioActive = this.designStudioService.designStudioActive;
    this.widgetData =  await this.widgetsService.getWidgetData(this.widgetID);
    this.widgetStyle = this.widgetData.style;
    if (!this.widgetStyle || Object.keys(this.widgetStyle).length === 0 || !this.designStudioActive) {
      this.widgetStyle = await this.designStudioService.getSessionStorageGlobalData();
      if(this.widgetStyle.backgroundImage){
        this.background = this.domSanitizer.bypassSecurityTrustStyle(`url(${this.widgetStyle.backgroundImage})`);
    }
    else if(this.widgetStyle.backgroundColor){
        this.background = this.widgetStyle.backgroundColor;
    }
    else{
        //this.background = 'transparent';
    }
    }
    this.colClass = `lg-col-${this.widgetStyle.itemStyle.gridColumn.lg} md-col-${this.widgetStyle.itemStyle.gridColumn.md} sm-col-${this.widgetStyle.itemStyle.gridColumn.sm}`;


    this.vendorService.userPlaceSub.subscribe(userPlace => {
      console.log('place', userPlace);
      if(userPlace.place || !this.vendorService.vendorSettings.vendorBasedOnKm) {
        this.getVendors();
      }
    });
    
  } 

  async getVendors() {
    if(!this.vendorService.vendorSettings.vendors.length) {
      this.loading = true;
      console.log("this.widgetData.vendorsList",this.widgetData.vendorsList);
      this.vendors = await this.widgetsService.getVendors(this.widgetData.vendorsList);
      console.log('this.vendors', this.vendors);
      this.loading = false;
    } else {
      this.vendors = this.vendorService.vendorSettings.vendors;
    }
  }

  getImgUrl(item: any) {
    let objName = '';
    let defaultImg = '';
    const imgType = 'mob';
    objName = 'image';
    if(!(objName in item)) {
      defaultImg = 'assets/img/img-preloader.png';
      return;
    }
    if(item[objName][imgType]) {
      return item[objName][imgType];
    }
    if(!item[objName][imgType] && item[objName]['url']) {
      return item[objName]['url'];
    }
    if(!item[objName][imgType] && !item[objName]['url']) {
      return defaultImg;
    }
  }

  onClickVendor(vendor) {
    if('sections' in vendor && vendor.sections.length) {
      this.router.navigate([`vendor-info/${encodeURL(vendor.displayName || vendor.name)}/${vendor.id}`]);
    } else {
      this.router.navigate([`shop/vendor/${encodeURL(vendor.displayName || vendor.name)}/${vendor.id}`]);
    }
  }

}
